import { User } from "@edl-development/edl-common";
import { CplRoles } from "src/app/enums/cpl-roles.enum";

export class UserHelper {        

    public static isParaeducator(user: User) {
        return this.hasRole(user, CplRoles.Paraeducator);
    }

    public static isEmergencyCert(user: User) {
        return this.hasRole(user, CplRoles.Emergency_Cert);
    }

    public static isVolunteer(user: User) {
        return this.hasRole(user, CplRoles.Volunteer);
    }

    private static hasRole(user: User, roleName: string) {
        return !!user.UserRoles &&
            user.UserRoles.map(userRole => userRole.RoleName).indexOf(roleName) !== -1;
    }
}